import { render } from "./SelectTypeComponent.vue?vue&type=template&id=3cf7347a&scoped=true"
import script from "./SelectTypeComponent.vue?vue&type=script&lang=js"
export * from "./SelectTypeComponent.vue?vue&type=script&lang=js"

import "./SelectTypeComponent.vue?vue&type=style&index=0&id=3cf7347a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf7347a"]])

export default __exports__